import React from "react";
import styled from "styled-components";
import { Link } from "../";
const Icon = styled.svg`
  height: 12px;
  margin-top: -1px;
  width: 8px;

  g {
    fill: ${props => props.theme.colors.action};
  }
`;
const IconLeft = styled(Icon)`
  margin-right: 8px;
`;
const IconRight = styled(Icon)`
  margin-left: 8px;
`;
export const PageLink = ({
  children,
  ...props
}) => {
  return React.createElement(Link, props, React.createElement(IconLeft, {
    viewBox: "0 0 8 12"
  }, React.createElement("g", {
    "stroke-width": "1",
    "fill-rule": "evenodd",
    transform: "translate(-4.000000, -2.000000)",
    "fill-rule": "nonzero"
  }, React.createElement("polygon", {
    id: "Path",
    points: "11.4013203 12.2928932 9.98710678 13.7071068 4.28 8 9.98710678 2.29289322 11.4013203 3.70710678 7.10842712 8"
  }))), children, React.createElement(IconRight, {
    viewBox: "0 0 8 12"
  }, React.createElement("g", {
    "stroke-width": "1",
    "fill-rule": "evenodd",
    transform: "translate(-4.000000, -2.000000)",
    "fill-rule": "nonzero"
  }, React.createElement("polygon", {
    id: "Path-14",
    points: "4.6 12.2928932 6.01421356 13.7071068 11.7213203 8 6.01421356 2.29289322 4.6 3.70710678 8.89289322 8"
  }))));
};
export const LinkRight = styled(PageLink)`
  ${IconLeft} {
    display: none;
  }
`;
export const LinkLeft = styled(PageLink)`
  ${IconRight} {
    display: none;
  }
`;
export const LinkLeftReverse = styled(LinkLeft)`
  color: #ffffff;
  &:hover,
  &:focus {
    color: #ffffff;
  }
  ${IconLeft} {
    g {
      fill: #ffffff;
    }
  }
`;
export const LinkRightReverse = styled(LinkRight)`
  color: #ffffff;
  &:hover,
  &:focus {
    color: #ffffff;
  }
  ${IconRight} {
    g {
      fill: #ffffff;
    }
  }
`;